import { createSlice } from "@reduxjs/toolkit";

export const harvestYourCrop = createSlice({
  name: "harvest_your_crop",
  initialState: {
    value: {
      status: false,
      data: {},
    },
  },
  reducers: {
    updateHarvestCrop: (state, action) => {
      state.value.status = true;
      state.value.data = action.payload;
    },
  },
});

export const { updateHarvestCrop } = harvestYourCrop.actions;

export default harvestYourCrop.reducer;
